import { Layers } from "lucide-react";
import DocSlot from "@/components/DocSlot";
import { useAuth } from "@/context/AuthContext";

// v1.0.19 WS3 — shared As Builts document container. Both roadmap entry points read/write the SAME
// existing Electrical Works document association (linked_to "electrical_works") — no new records or storage.
export const AS_BUILTS_LINKED_TO = "electrical_works";
export const AS_BUILTS_CATEGORY = "Electrical Works";

export const asBuiltsDocs = (docs) => (docs || []).filter((d) => d.linked_to === AS_BUILTS_LINKED_TO);

export function AsBuiltsChip({ docs, onClick, testId, side = "right" }) {
  const { readOnly } = useAuth();
  const items = asBuiltsDocs(docs);
  const attached = items.length > 0;
  const line = side === "right"
    ? "hidden h-px w-6 shrink-0 bg-gray-300 xl:block"
    : "hidden h-px w-6 shrink-0 bg-gray-300 xl:block xl:order-2";
  const pos = side === "right"
    ? "xl:absolute xl:left-full xl:top-1/2 xl:-translate-y-1/2"
    : "xl:absolute xl:right-full xl:top-1/2 xl:-translate-y-1/2";
  return (
    <div className={`mt-2 flex items-center ${pos} xl:mt-0`} data-testid={`${testId}-flow`}>
      {side === "right" && <span className={line} />}
      <button
        type="button"
        data-testid={testId}
        data-attached={attached ? "true" : "false"}
        onClick={onClick}
        title={readOnly ? "View / download As Builts documents (read-only)" : "Open As Builts documents"}
        className={`w-52 shrink-0 rounded-md border px-3 py-2 text-left shadow-sm transition-colors ${
          attached ? "border-emerald-300 bg-emerald-50 hover:border-emerald-400" : "border-dashed border-gray-300 bg-gray-50/80 hover:border-gray-400"}`}
      >
        <div className={`mb-1 flex items-center gap-1.5 text-[9px] font-semibold uppercase ${attached ? "text-gray-800" : "text-gray-500"}`} style={{ letterSpacing: "0.1em" }}>
          <Layers size={11} strokeWidth={1.8} /> As Builts
        </div>
        {attached ? (
          <>
            <div className="font-mono-data text-sm font-semibold text-gray-950" data-testid={`${testId}-count`}>{items.length} Document{items.length > 1 ? "s" : ""}</div>
            <div className="text-[10px] font-semibold uppercase text-emerald-700" style={{ letterSpacing: "0.05em" }} data-testid={`${testId}-state`}>Attached</div>
          </>
        ) : (
          <div className="text-[10px] font-medium uppercase text-gray-400" style={{ letterSpacing: "0.06em" }} data-testid={`${testId}-state`}>No Documents</div>
        )}
      </button>
      {side === "left" && <span className={line} />}
    </div>
  );
}

export function AsBuiltsForm({ project, docs, refreshDocs }) {
  return (
    <div data-testid="as-builts-form">
      <p className="mb-3 rounded-sm border border-gray-200 bg-gray-50 px-3 py-2 text-[11px] leading-relaxed text-gray-500">
        Shared project container — the same As Builts documents are shown in the Electrical and NBN roadmaps.
        Attachment presence only: it never affects Electrical Works completion, NBN completion, financials or project completion.
      </p>
      <DocSlot projectId={project.id} linkedTo={AS_BUILTS_LINKED_TO} category={AS_BUILTS_CATEGORY}
        label="As Builts Documents (PDF, Word, Excel, DWG…)" docs={docs} onUploaded={refreshDocs} />
    </div>
  );
}
